import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

interface TeamRestrictProps {
  allTeams: boolean
  teamRestrict: string[]
}

const TeamRestrict: React.FC<TeamRestrictProps> = ({
  allTeams,
  teamRestrict
}) => {
  const [bold, text] = React.useMemo(() => {
    if (allTeams) {
      return [true, 'All Users']
    }

    const numRoles = teamRestrict.length
    return [false, `${numRoles} team${numRoles === 1 ? '' : 's'}`]
  }, [allTeams, teamRestrict])

  const classes = useStyles()

  return <div className={clsx(classes.root, bold && classes.bold)}>{text}</div>
}

export default TeamRestrict
